import { Duration } from "luxon";

export const getTimeString = (timeInMinutes: number) => {
  const duration =
    Duration?.fromObject({ minutes: timeInMinutes })?.toFormat(
      "hh 'hr' mm 'min'"
    ) || "";
  return duration;
};
